const e = {}, t = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: e
}, Symbol.toStringTag, { value: "Module" }));
export {
  t as _,
  e as f
};
//# sourceMappingURL=__vite-browser-external-BYRIRx8p.js.map
